import {
  IFlow,
  useWorkPageStore,
  useWorkToolbarOptions,
  WorkToolbar,
  WorkToolbarActionsContainer,
  WorkToolbarSaveJsonButton,
} from '@diana/core';
import { Box } from '@mui/material';

const WorkPageToolbar = ({ flow }: { flow?: IFlow }) => {
  const work = useWorkPageStore((store) => store.work);

  const flowId = work?.flowId;
  const workId = work?.id;

  const {
    videoChatActiveUsers,
    isVideoChatButtonShown,
    isCommentsButtonShown,
    isCommentsCountShown,
    isPrintButtonShown,
    isDuplicateWorkEnabled,
    isAddNewWorkEnabled,
    onWorkDeleteSuccess,
  } = useWorkToolbarOptions({ flow });

  return work && flow ? (
    <WorkToolbar
      printerContext={work.printerContext}
      workId={workId!}
      workUsers={work.users}
      steps={work.steps}
      flowId={flowId!}
      flowOriginId={flow?.flowOriginId ?? ''}
      canDelete={work.canDelete}
      canDelegate={work.canDelegate}
      workCode={work.workCode}
      status={work.status!}
      displayName={work.displayName}
      companies={work.companies}
      hideWorkLevelViewers={flow.hideWorkLevelViewers}
      videoChatUsersCount={videoChatActiveUsers}
      onWorkDeleteSuccess={onWorkDeleteSuccess}
      isVideoChatButtonShown={isVideoChatButtonShown}
      isCommentsButtonShown={isCommentsButtonShown}
      isPrintButtonShown={isPrintButtonShown}
      isDuplicateWorkEnabled={isDuplicateWorkEnabled}
      isAddNewWorkEnabled={isAddNewWorkEnabled}
      isCommentsCountShown={isCommentsCountShown}
      showSidePeek={flow?.featureFlags?.isSingleScreenWorkUpdate}
      actions={
        <>
          <WorkToolbarSaveJsonButton work={work} />
          <WorkToolbarActionsContainer workTasks={work.tasks} />
        </>
      }
    />
  ) : null;
};

export const WorkPageRightHeader = ({ flow }: { flow?: IFlow }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <WorkPageToolbar flow={flow} />
    </Box>
  );
};
